import { EChatImagesActionTypes } from '../../actions/chatImages';
import { IChatImageFile } from '../../repositories/chats/entities/file/ChatImageFile';
import { TAppState, ERequestApiStatus } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function chatImagesReducer(state: TAppState, action: TReduxActions): TAppState {
  // @ts-expect-error
  const openedChat = action?.payload?.chatId && state.openedChats[action.payload.chatId];
  const files: IChatImageFile[] = openedChat?.images?.files || [];

  if (!openedChat) {
    return {
      ...state,
    };
  }

  switch (action.type) {
    case EChatImagesActionTypes.SetChatImagesPending:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            images: {
              ...openedChat.images,
              status: ERequestApiStatus.Pending,
            },
          },
        },
      };

    case EChatImagesActionTypes.SetChatImagesSucceed:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            images: {
              files:
                action.payload.files && action.payload.files?.images.length
                  ? files.concat(action.payload.files.images)
                  : files,
              page: { ...action.payload.page },
              status: ERequestApiStatus.Succeed,
            },
          },
        },
      };

    case EChatImagesActionTypes.SetChatImagesFailed:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            images: {
              ...openedChat.images,
              status: ERequestApiStatus.Failed,
            },
          },
        },
      };

    case EChatImagesActionTypes.SetChatImagesEmpty:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            images: null,
          },
        },
      };

    // Добавляет изображения в начало уже загруженного списка файлов чата, пропуская дубли по uid
    case EChatImagesActionTypes.AddChatImages: {
      const newImages = action.payload.images.filter(({ uid }) => !files.some(file => file.uid === uid));

      if (!openedChat.images || !newImages.length) {
        return state;
      }

      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            images: {
              ...openedChat.images,
              files: newImages.concat(files),
            },
          },
        },
      };
    }

    default:
      return state;
  }
}
